import type { LabelJob, LabelJobMeta } from './types.js';

const encoder = new TextEncoder();
const decoder = new TextDecoder();

export interface LabelJobOptions {
  description: string;
  /** Defaults to a random UUID. */
  id?: string;
  /** Defaults to now. */
  createdAt?: Date;
  /** What the label is (for the print log). */
  meta?: LabelJobMeta;
}

/**
 * Wraps ZPL from `@enp/domain` (`renderLotLabel`, `renderTestLabel`) as a print job. The ZPL
 * sets `^CI28`, so UTF-8 is the right encoding (domain output is pure ASCII anyway).
 */
export function createLabelJob(zpl: string, options: LabelJobOptions): LabelJob {
  return {
    id: options.id ?? crypto.randomUUID(),
    zpl: encoder.encode(zpl),
    description: options.description,
    createdAt: (options.createdAt ?? new Date()).toISOString(),
    ...(options.meta ? { meta: options.meta } : {}),
  };
}

/** The job's ZPL as text (previews, logs). */
export function jobZpl(job: LabelJob): string {
  return decoder.decode(job.zpl);
}

/** Base64 of the job bytes (the Capacitor plugin bridge carries strings, not bytes). */
export function toBase64(bytes: Uint8Array): string {
  let binary = '';
  for (let i = 0; i < bytes.length; i += 0x8000) {
    binary += String.fromCharCode(...bytes.subarray(i, i + 0x8000));
  }
  return btoa(binary);
}
